import Link from 'next/link';
import Image from 'next/image';
import cn from 'classnames';
import LinkedInIcon from '@/public/img/icons/IconLinkedIn.svg';

export interface LinkedInButtonProps {
	className?: string;
	href: string;
}

const LinkedInButton = (props: LinkedInButtonProps) => {
	const { className = '', href } = props;

	return (
		<Link
			href={href}
			rel="noopener noreferrer"
			target="_blank"
			className={cn(
				'grid aspect-square w-8 rounded-full bg-white shadow-md',
				className,
			)}
			data-position="FOOTER"
			data-location="NAVIGATION"
			data-type="LINK"
			data-text="HVAC LinkedIn"
			data-action="EXTERNAL LINK"
		>
			<Image src={LinkedInIcon} alt="LinkedIn Icon" className="m-auto" />
		</Link>
	);
};

export default LinkedInButton;
